import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Invitation} from '@app/admin/client.service';
import {deserialize} from '@app/serializable';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class InvitationService {
    constructor(private http: HttpClient) {}

    getInvitation(id: string, code: string): Observable<Invitation> {
        return this.http
            .get<Invitation>(`/api/workspace/invitation/${id}`, { params: { verify_code: code } })
            .pipe(map((results) => deserialize(Invitation, results)));
    }

    acceptInvitation(id: string, code: string, name: string, email: string): Observable<any> {
        const body = {
            verify_code: code,
            name,
            email,
        };
        return this.http.post(`/api/workspace/invitation/${id}/accept/`, body);
    }

    invite(clientId: string, invitations: Invitation[]): Observable<any> {
        const url = `/api/workspace/client/${clientId}/invite/`;
        const options = {
            invitations,
            withCredentials: true,
        };
        return this.http.post(url, options);
    }

    revokeInvitation(invitationId: string) {
        const url = `/api/workspace/invitation/${invitationId}/`;
        const options = {
            withCredentials: true,
        };
        return this.http.delete(url, options);
    }

    resendInvitation(invitationId: string) {
        const url = `/api/workspace/invitation/${invitationId}/resend/`;
        const options = {
            withCredentials: true,
        };
        return this.http.post(url, options);
    }

    getInvitationLink(clientId: string) {
        const url = `/api/workspace/client/${clientId}/inviteLink/`;
        const options = {
            withCredentials: true,
        };
        return this.http.post(url, options);
    }
}
